import request from '@/router/axios'
import env from '@/config/env'

// 分页
export function pageApi(params) {
  return request({
    url: env.officeUrl + '/asset-user/v1/asset-page',
    method: 'get',
    params
  })
}
// 发起调拨-归还
export function userTransfer(params) {
  return request({
    url: env.officeUrl + '/asset-user/v1/transfer',
    method: 'post',
    data: params
  })
}
// 调拨-归还资产操作
export function userReceive(params) {
  return request({
    url: env.officeUrl + '/asset-user/v1/receive',
    method: 'post',
    data: params
  })
}
// 我的资产和待接收数量
export function assetCount(params) {
  return request({
    url: env.officeUrl + '/asset-user/v1/asset-count',
    method: 'get',
    params
  })
}
// 待接收资产分页列表
export function receivePage(params) {
  return request({
    url: env.officeUrl + '/asset-user/v1/receive-page',
    method: 'get',
    params
  })
}
// 我的资产详情
export function myAssetDetail(params) {
  return request({
    url: env.officeUrl + '/asset-user/v1/detail/' + params,
    method: 'get'
  })
}
